import Box from '@component/Box';
import { useSession } from 'next-auth/react';
import CartApi from 'pages/api/cart/cart';
import React, { useEffect, useState } from 'react';
import Divider from '../Divider';
import FlexBox from '../FlexBox';
import Typography, { Span } from '../Typography';

const CheckoutSummary2: React.FC = () => {
  const { data: session, status } = useSession();
 const loading = status === 'loading';;
  const token = session?.accessToken.toString();
  const [cartList, setCartList] = useState([]);

  useEffect(() => {
    const getUserCart = async () => {
      try {
        const res = await CartApi.getCart(token);
        const { data } = res;
        console.log('DATA', data);
        let _cartItem = [];
        data.forEach((cartItem) => {

          console.log('CART ITEM ->', cartItem)
          let _item = {
            quantity: cartItem.quantity,
            name: cartItem.title,
            price: +cartItem.actualPrice,
            id: cartItem.id,
            stock: cartItem.stock,
            subTotal: cartItem.subTotal,
            deliveryCost: cartItem.deliveryCost,
          };
          _cartItem.push(_item);
        });
        setCartList(_cartItem);
      } catch (err) {
        console.log('ERROR getting user cart', err);
      }
    };
    if (!loading) {
      getUserCart();
    }
  }, [loading]);

  const getTotalPrice = () => {
    return cartList.reduce((accumulator, item) => accumulator + Number(item.price) * item.quantity, 0) || 0;
  };

  const getTotalDeliveryPrice = () => {
    return cartList.reduce((accumulator, item) => accumulator + item.deliveryCost, 0) || 0;
  };

  return (
    <Box>
      <Typography color="secondary.900" fontWeight="700" mb="1.5rem">
        Your order
      </Typography>

      {cartList.map((item) => (
        <FlexBox justifyContent="space-between" alignItems="center" mb="1.5rem" key={item.name}>
          <Typography>
            <Span fontWeight="700" fontSize="14px">
              {item.quantity}
            </Span>{' '}
            x {item.name}
          </Typography>
          <Typography>MYR {item.subTotal.toFixed(2)}</Typography>
        </FlexBox>
      ))}

      <Divider bg="gray.300" mb="1.5rem" />

      <FlexBox justifyContent="space-between" alignItems="center" mb="0.5rem">
        <Typography color="text.hint">Subtotal:</Typography>
        <Typography fontWeight="700">MYR {getTotalPrice().toFixed(2)}</Typography>
      </FlexBox>

      <FlexBox justifyContent="space-between" alignItems="center" mb="0.5rem">
        <Typography color="text.hint">Shipping:</Typography>
        <Typography fontWeight="700">MYR {getTotalDeliveryPrice().toFixed()}</Typography>
      </FlexBox>

      <Divider bg="gray.300" mb="0.5rem" />

      <FlexBox fontWeight="700" justifyContent="space-between" alignItems="center" mb="0.5rem">
        <Typography>Total:</Typography>
        <Typography fontWeight="700">MYR {(getTotalPrice() + getTotalDeliveryPrice()).toFixed()}</Typography>
      </FlexBox>
    </Box>
  );
};

const cartList = [
  {
    name: 'iPhone 12',
    quantity: 1,
    price: 999,
  },
  {
    name: 'iPhone 12 pro',
    quantity: 1,
    price: 1199,
  },
  {
    name: 'iPhone 12 pro max',
    quantity: 1,
    price: 1299,
  },
];

export default CheckoutSummary2;
